import { Check, X } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";

export interface YesNoEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function YesNoEntryValue({ value, inputLabel, size, ...props }: YesNoEntryValueProps) {
    const normalised = value?.toString().trim().toLowerCase();
    const isYes = normalised === "yes" || normalised === "true";
    const isNo = normalised === "no" || normalised === "false";

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            {isYes ? (
                <EntryValueChip icon={Check} tone="positive" size={size}>
                    Yes
                </EntryValueChip>
            ) : isNo ? (
                <EntryValueChip icon={X} tone="muted" size={size}>
                    No
                </EntryValueChip>
            ) : (
                <EntryValueChip size={size}>{value || "None"}</EntryValueChip>
            )}
        </BaseEntryValue>
    );
}
